export const constant = {
  // baseUrl:"http://127.0.0.1:5001/"
  // baseUrl:"https://backend-3nxm.onrender.com/"not working
  // baseUrl:"https://backend-tvjv.onrender.com/"not working
  // baseUrl:'https://backend-egwu.onrender.com/'not working
  // baseUrl:`http://server.ovf.bgg.mybluehostin.me:5001/`not working
  // working
  // baseUrl:'https://backend-v9n5.onrender.com/' 
  baseUrl:"https://backend-8pni.onrender.com/"
};
